import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=2f2a1286&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=2f2a1286&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a1286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2a1286')) {
      api.createRecord('2f2a1286', component.options)
    } else {
      api.reload('2f2a1286', component.options)
    }
    module.hot.accept("./Selector.vue?vue&type=template&id=2f2a1286&scoped=true", function () {
      api.rerender('2f2a1286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/MultiSelectionBadge/Selector.vue"
export default component.exports